import ComponentSwitch from './ComponentSwitch';

export default ComponentSwitch;
